(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 8318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(4178);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(797);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4532);
/* harmony import */ var _app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1817);
/* harmony import */ var _app_component_commons_popover_Popover__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8245);
/* harmony import */ var _app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7923);
/* harmony import */ var _app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7213);









var Index = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), mode = ref[0], setMode = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // window.analytics.page("viewed");
        if (window.innerWidth < 768) {
            setMode("mobile");
        } else {
            setMode("desktop");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "About | Storage Unit Auction List",
                description: "Storage Unit Auction list is a website that lists all the storage unit auctions happening in the United States. There are tens of thousands of auctions each month, so there is always something happening near you."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                nearFoot: false,
                topFooter: "md:!mt-[7.75rem] mt-[5.25rem]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container mx-auto ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-[5.75rem] flex flex-col items-center justify-center text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-warning-500 text-regular-tight md:text-large-none md:font-bold font-medium uppercase",
                                        children: "Company"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-4 md:mt-3.5 text-neutral-900 font-bold md:!text-title1 text-title3 leading-[2.125rem]",
                                        children: "About Us"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-4 md:mt-14 bg-map-desktop-2 bg-contain md:bg-auto bg-top bg-no-repeat min-h-[36rem] lg:w-[62rem] xl:w-[68.125rem] mx-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-row items-center justify-between px-3 md:h-auto h-[8rem]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "shadow-lv5 bg-white p-4.5 w-[18.875rem] rounded-xl md:block hidden",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_popover_Popover__WEBPACK_IMPORTED_MODULE_5__/* .PopoverOne */ .UJ, {
                                                    visible: true,
                                                    animate: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "shadow-lv4 bg-white p-3.5 w-[20.625rem] rounded-xl md:block hidden",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_popover_Popover__WEBPACK_IMPORTED_MODULE_5__/* .PopoverTwo */ .wK, {
                                                    visible: true,
                                                    animate: ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "md:mt-[7.438rem] gradient-main md:rounded-[3rem] w-full p-4.5 md:p-[2.375rem]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-large-normal md:text-title2 text-neutral-900 font-bold",
                                                children: "Our History"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "mt-3.5 md:mt-4.5 text-neutral-700 text-small-normal md:text-xl md:leading-10 text-justify",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: _app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .history["paragraf-1"] */ .m8["paragraf-1"]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "md:mt-4.5",
                                                        children: _app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .history["paragraf-2"] */ .m8["paragraf-2"]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-8 md:mt-12 flex flex-col md:flex-row items-center md:items-start lg:items-center md:space-x-3 xl:space-x-5 lg:w-[61rem] xl:w-[68.125rem] mx-auto px-4.5 md:px-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "min-w-[10.188rem] md:min-w-[20.5rem] relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute left-[1rem] top-[1rem] md:left-10 md:top-7 bg-[#F0F5FF] rounded-[1.875rem] w-[7.951rem] h-[7.951rem] md:w-64 md:h-64 z-0"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                src: "/images/map-color.png",
                                                alt: "about-us",
                                                className: "w-[10.188rem] md:w-full z-10 relative"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col space-y-3 md:space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-neutral-900 font-bold text-large-normal md:text-title2 text-center md:text-left",
                                                children: "We are only going to improve"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-neutral-700 text-small-normal md:text-xl md:leading-[1.875rem] text-justify md:pr-10",
                                                children: _app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .improve["paragraf-1"] */ .yP["paragraf-1"]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-16 md:mt-[7.75rem] relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute rounded-full left-[-5rem] bottom-[4rem] bg-primary-50 w-[10.125rem] h-[10.125rem] z-0 hidden md:block"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute rounded-full right-[-5rem] bottom-[7rem] bg-secondary-50 w-[10.125rem] h-[10.125rem] z-0 md:block hidden"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container mx-auto ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col justify-center items-center lg:w-[68.125rem] mx-auto md:px-0 px-4.5 ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute left-[-1.5rem] top-[-1rem] lg:left-[-10rem] lg:top-[1rem] xl:left-[-15rem] xl:top-[1rem] z-0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        src: "/images/avatar/new-circle-1.svg",
                                                        alt: "about-us",
                                                        className: "lg:w-[6.563rem] lg:h-[6.563rem] md:w-14 md:h-14 w-7 h-7"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute left-[-2rem] top-full lg:left-[-8rem] lg:top-[15rem] xl:left-[-10rem] xl:top-[15rem] z-0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        src: "/images/avatar/new-circle-2.svg",
                                                        alt: "about-us",
                                                        className: "md:w-[4.25rem] md:h-[4.25rem] w-[2.875rem] h-[2.875rem]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute right-[-1rem] top-full md:right-[-3rem] md:top-[1rem] lg:right-[-5rem] lg:top-[1rem] xl:right-[-15rem] xl:top-[1rem] z-0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        src: "/images/avatar/new-circle-1.svg",
                                                        alt: "about-us",
                                                        className: "md:w-[2.875rem] md:h-[2.875rem] w-[2.125rem] h-[2.125rem]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute right-[-2rem] top-[-2rem] md:right-[-5rem] md:top-[16rem] lg:right-[-7rem] xl:right-[-12rem] lg:top-[14rem] z-0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        src: "/images/avatar/new-circle-4.svg",
                                                        alt: "about-us",
                                                        className: "md:w-24 md:h-24 w-12 h-12"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-neutral-900 font-bold text-large-normal md:text-[2.5rem] md:leading-[3.5rem] text-center",
                                                    children: _app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .customer_satisfaction.title */ .yn.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mt-3 md:mt-6 text-neutral-700 text-small-normal md:text-xl md:!leading-[1.875rem] text-justify md:text-center md:w-[40.5rem] break-words md:break-normal",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: _app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .customer_satisfaction["paragraf-1"] */ .yn["paragraf-1"]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "mt-[2.375rem] w-full md:w-[20.625rem] shadow-lv4 bg-white flex flex-col items-center justify-center p-3.5 rounded-xl",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "font-bold text-neutral-900 text-title3",
                                                    children: "Thank You \uD83D\uDE0A"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-center text-small-normal text-neutral-600 mt-2",
                                                    children: [
                                                        " ",
                                                        "for choosing Storage Unit Auction List, we look forward to growing each day with you!"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mx-auto ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-[5.25rem] md:mt-[7.75rem] flex flex-col items-center justify-center w-full lg:w-[54.25rem] mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-neutral-900 font-bold text-title4 leading-[2.125rem] md:text-title1 md:!text-[2.5rem] text-center md:w-[40rem] px-4.5 md:px-0",
                                    children: [
                                        "The Complex Inner workings of",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-gradient-7 block",
                                            children: "StorageUnitAuctionList.com"
                                        }),
                                        " ",
                                        "How We Do It?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-6 md:mt-12 relative flex flex-col items-center justify-center w-full",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute z-0 top-[3rem] gradient-main rounded-[3rem] w-full md:w-[40.25rem] h-full md:h-[19.375rem]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex flex-col md:flex-wrap md:flex-row justify-center items-center md:gap-x-[2.125rem] gap-y-3.5 relative w-full md:px-0 px-4.5",
                                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .weDoIt_1 */ .cE).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_app_helpers_ContentList__WEBPACK_IMPORTED_MODULE_6__/* .weDoIt_2 */ .YV)).map(function(e, key) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "w-full md:w-5/12 lg:w-[16.5rem] bg-white shadow-lv4 rounded-3xl py-4.5 px-[1.375rem] flex flex-col items-center justify-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "rounded-[0.875rem] p-3.5 ".concat(e.className),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(e.Icon, {
                                                                size: "34"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "font-bold text-neutral-900 text-title3 mt-6",
                                                            children: e.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-large-normal text-neutral-900 mt-3",
                                                            children: e.subtitle
                                                        })
                                                    ]
                                                }, key);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ }),

/***/ 797:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,659,774,888,179], function() { return __webpack_exec__(8318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);